/**
Project: Voice Panel (c)
Title: App URLs 
Description: URLs of Application 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
export const AppURLProps = {
  home: "/",
  signin: "/signin",
  signinSilentStart: "/signin-silent-start",
  signinSilentEnd: "/signin-silent-end",
  signout: "/signout",
  noAccountNumber: "/no-account",
  noRegion: "/no-regions",
  error: "/error",
  pageNotFound: "/page-not-found",
  ErrorFrame: "/error-frame",
};
